import React, { useState } from "react";
import { format, parseISO } from "date-fns";
import { fr } from "date-fns/locale";
import { CalendarDays, X } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

// Sélecteur de date en français (jj/mm/aaaa) ; valeur échangée au format AAAA-MM-JJ.
export const DatePickerFr = ({ value, onChange, placeholder = "jj/mm/aaaa", testid, minDate }) => {
  const [open, setOpen] = useState(false);
  const selected = value ? parseISO(value) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <div className="relative">
        <PopoverTrigger asChild>
          <button type="button" data-testid={testid}
            className="h-11 w-full rounded-md border border-input bg-white px-3 pr-8 text-left text-sm font-data flex items-center gap-2 hover:bg-slate-50">
            <CalendarDays className="h-4 w-4 text-slate-500 shrink-0" />
            <span className={selected ? "text-slate-900" : "text-slate-400"}>
              {selected ? format(selected, "dd/MM/yyyy") : placeholder}
            </span>
          </button>
        </PopoverTrigger>
        {selected && (
          <button type="button" onClick={() => onChange("")} aria-label="Effacer la date" title="Effacer la date"
            className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-700" data-testid={testid ? `${testid}-clear` : undefined}>
            <X className="h-4 w-4" />
          </button>
        )}
      </div>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" locale={fr} weekStartsOn={1} selected={selected} defaultMonth={selected || (minDate ? parseISO(minDate) : undefined)}
          disabled={minDate ? { before: parseISO(minDate) } : undefined}
          onSelect={(d) => { onChange(d ? format(d, "yyyy-MM-dd") : ""); setOpen(false); }} initialFocus />
      </PopoverContent>
    </Popover>
  );
};
